import React from 'react'
import Header from '../ui-kit/header/Header';
import Link from 'next/link';
import ProjectCard from '../ui-kit/cards/ProjectCard';
import { IProject } from '../../models/Project';
import LinkWithChevron from '../ui-kit/general/LinkWithChevron';
import Grid from '../ui-kit/layout/Grid';

type Props = {
	projects: IProject[]
}

const ProjectsSection = ({ projects }: Props) => {

	return (
		<section className="my-8">
			<Grid title="Proyectos" viewAll={{ href: '/proyectos', text: 'Ver Todos' }}>
				{projects.map(project => <ProjectCard key={project.id} project={project} />)}
			</Grid>
		</section>
	)
}

export default ProjectsSection
